import { Pipe, PipeTransform } from '@angular/core';
import { Rate } from '@core/models/edition.model';

@Pipe({
  name: 'editionRates',
})
export class EditionRatesPipe implements PipeTransform {
  transform(rates: Rate[], category: string): Rate[] {
    return rates.filter((rate) => rate.categories.includes(category));
  }
}
